module.exports = __webpack_public_path__ + "static/studio-b-booth-e9e7636aca9245f89d28fb7df872db0c.jpg";